import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  p {
    margin: 0;
  }
  @media only screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
  }
`;

export const HeaderTitle = styled.p`
  font-size: 30px;
  font-weight: 600;
  color: #1c1b3a;
`;

export const HeaderItemLeft = styled.div`
  display: flex;
  align-items: center;
  column-gap: 15px;
  @media only screen and (max-width: 1000px) {
    display: flex;
    justify-content: space-between;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  column-gap: 30px;
  min-height: 800px;
  @media only screen and (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    row-gap: 50px;
  }
`;

export const NavTextLink = styled(NavLink)`
  align-self: center;
  text-decoration: none;
  color: black;
  &.active {
    color: #2dcafc;
  }
`;

export const ArrowBack = styled.img`
  height: 25px;
  width: auto;
`;

export const CardItemContainer = styled.div`
  padding: 0 20px;
  background-color: white;
  margin-top: 30px;
  margin-bottom: 20px;
`;

export const CardHeaderWithButton = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export const CardContent = styled.div`
  margin-top: 20px;
`;

export const HeaderText = styled.h3``;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
`;
